import type { BundledPackagePrice } from "@b2bportal/core-packages";
import { useModuleBEM } from "@b2bportal/core-themes";
import { PackagePriceText } from "@tenant/packages";
import { usePackagePriceSummary } from "./hook";
import styles from "./PackagePriceSummary.module.scss";

interface PackagePriceSummaryProps {
  price?: BundledPackagePrice;
}

export const PackagePriceSummary = ({
  price,
}: PackagePriceSummaryProps = {}) => {
  const [block, cn] = useModuleBEM(styles, "PackagePriceSummary");
  const {
    context: {
      showPointsPricing,
      hasTenantSpecific,
      text,
      packageType,
      shouldDisplay,
      totalPackageSavings,
    },
  } = usePackagePriceSummary(price);

  return shouldDisplay ? (
    <div className={block}>
      {totalPackageSavings && (
        <div className={cn("savings-banner")} role="status" aria-live="polite">
          {totalPackageSavings}
        </div>
      )}
      <PackagePriceText
        showPointsPricing={showPointsPricing}
        hasTenantSpecific={hasTenantSpecific}
        unitPriceRewards={text.perUnitRewards}
        unitPrice={text.perUnitPrice}
        totalPrice={text.totalPrice}
        packageType={packageType}
      />
    </div>
  ) : null;
};
